const setLayoutFeed = (item,widget) => {
  const text = widget.querySelector('.c-editorial-feed__description');

  if(text) {
    text.innerHTML = item.text;
  }
}

export default setLayoutFeed;
